<template>
  <div class="user">
    <div class="contentMain">
      <div class="title">
        <span>菜单管理</span>
      </div>
      <div class="main">
        <div class="main-right" ref="mainRight">
          <!-- 搜索框部分 -->
          <div class="searchValue">
          	<div class="leftBtn">
          		<el-input placeholder="请输入菜单标题" size="mini" v-model="searchValue" clearable>
          			<!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
          		</el-input>
          		<!-- 修改这里：将el-icon-search改为el-icon-Ssearch -->
          		<el-button type="primary" :loading="loading" icon="el-icon-Ssearch" size="mini"
          					@click="handleSearch">查询</el-button>
          	</div>
          	<div class="rightBtn">
          		<el-button type="primary" :loading="loading" icon="el-icon-plus" size="mini"
          					@click="addMenuhandClick(0)">新增</el-button>
          		<el-button :loading="loading" icon="el-icon-refresh" size="mini"
          					@click="handleRefresh">刷新</el-button>
          		<el-button icon="el-icon-s-tools" size="mini" @click="handleSettings">设置</el-button>
          		<!-- <el-button icon="el-icon-full-screen" size="mini" @click="handleFullScreen">全屏</el-button> -->
          	</div>
          </div>
          <div class="content">
            <el-table :data="tableData" row-key='id' :default-expand-all="isExpandAll"
                      :expand-row-keys="expandedRowKeys" @row-dblclick="handledbRow"
                      :style="{ width: windowWidth + 'px' }"
                      :tree-props="{children: 'children',hasChildren:true}">
              <!-- 树形展开图标列 -->
              <el-table-column label="菜单名称" prop="label" width="168"></el-table-column>
              <el-table-column fixed="left" label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="图标" prop="icon" align="center" width="66">
                <template slot-scope="scope">
                  <i :class="scope.row.icon" style="font-size: 18px;"></i>
                </template>
              </el-table-column>
              <el-table-column label="排序号" prop="order" align="center" width="80"></el-table-column>
              <el-table-column label="类型" prop="type" align="center" width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.type === 'M'" type="success"
                          size="mini">{{ scope.row.type === 'M' ? '目录' : scope.row.type === 'C' ? '菜单' : '按钮' }}</el-tag>
                  <el-tag v-else-if="scope.row.type === 'C'" type="warning"
                          size="mini">{{ scope.row.type === 'M' ? '目录' : scope.row.type === 'C' ? '菜单' : '按钮' }}</el-tag>
                  <el-tag v-else type="danger"
                          size="mini">{{ scope.row.type === 'M' ? '目录' : scope.row.type === 'C' ? '菜单' : '按钮' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, inx) in tableRows" :key="inx" border='false' :type="col.type"
                               :prop="col.prop" :label="col.name"
                               :width="columnWidth(col, tableData)"></el-table-column>
              <!-- edit -->
              <el-table-column fixed="right" label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <div class="editbox" style="display: flex;justify-content: center;">
                    <el-link style="font-size:12px;" size="mini"
                             @click="handleEdit(scope.row)">编辑</el-link>
                    <el-link style="font-size:12px;margin-left: 8px;" size="mini" type="danger"
                             @click="handleDelete(scope.row.id)">删除</el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="foot">
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="pageNum" :page-sizes="[5, 10, 20]" :page-size="pageSize" :total="totalSize"
                           layout="total, sizes, prev, pager, next, jumper" background>
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 新增Model -->
      <div class="addMenuDiglog">
        <el-dialog title="新增菜单" :visible.sync="addMenuDialog" width="28%" :modal="false"
                   :before-close="handleClose">
          <!-- 表单 -->
          <el-form ref="form" :model="addForm" label-width="88px" size="mini">
            <el-row :gutter="20">
              <el-col :span="v.spanRows" type="flex" v-for="(v,i) in formType" :key="i">
                <!-- input -->
                <el-form-item v-if="v.type == 'input'" :label="v.label" :prop="v.modelValue">
                  <el-input :suffix-icon='v.prefix' v-model="$data.addForm[v.modelValue]"
                            :placeholder="v.placeholder" @focus='OpenIconsFocus(v,i)'></el-input>
                  <!-- icon自选区域 -->
                  <el-dialog title="选择一个菜单图标" :visible.sync="OpenIcons" width="48%" :modal="false"
                             :before-close="handleIconClose">
                    <div class="icon-list">
                      <div v-for="(v, index) in icons" :key="index" :value="v" class="icon-item"
                           @click="selectIcon(v)">
                        <i :class="v.icon" style="font-size: 18px;"></i>
                        <span style="font-size: 12px;">{{v.title}}</span>
                      </div>
                    </div>
                  </el-dialog>
                </el-form-item>
                <!-- select -->
                <el-form-item v-if="v.type == 'MenuSelect'" :label="v.label" :prop="v.modelValue">
                  <el-select v-model="$data.addForm[v.modelValue]" filterable
                             :placeholder="v.placeholder" @focus="sname(v,i)" @change="scsname">
                    <el-option v-for="(item,index) in $data[v.op]" :key="index" :label="item.label"
                               :value="item.value" :disabled="item.disabled">
											<span
                          style="float: center;font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="v.type == 'firstSelect'" :label="v.label" :prop="v.modelValue">
                	<el-select v-model="$data.addForm[v.modelValue]" filterable
                				:placeholder="v.placeholder" :disabled="Pidisabled" @focus="sname(v,i)"
                				@change="scname">
                		<!-- 关键修改：使用selectOptions作为数据源，value绑定id，label显示label -->
                		<el-option v-for="item in selectOptions" :key="item.id" :label="item.label"
                					:value="item.id">
                			<span style="float: center;font-size: 12px">{{ item.label }}</span>
                		</el-option>
                	</el-select>
                </el-form-item>
                <!-- 新增表单中的菜单名称 -->
                <el-form-item v-if="v.type == 'selectWithInput'" :label="v.label" :prop="v.modelValue">
                  <el-select v-model="$data.addForm[v.modelValue]" filterable allow-create
                             default-first-option :placeholder="v.placeholder" @focus="sname(v,i)"
                             @change="handleMenuNameChange" @blur="handleMenuNameBlur" style="width: 100%">
                    <el-option v-for="(item,index) in combinedMenuOptions" :key="index"
                               :label="item.label" :value="item.label">
                      <span style="float: center;font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="v.type == 'select'" :label="v.label" :prop="v.modelValue">
                  <el-select v-model="$data.addForm[v.modelValue]" filterable
                             :placeholder="v.placeholder" @focus="sname(v,i)" @change="scsname">
                    <el-option v-for="(item,index) in $data[v.op]" :key="index" :label="item.label"
                               :value="item.id" :disabled="item.disabled">
											<span
                          style="float: center;font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
                <!-- inputNumber -->
                <el-form-item v-if="v.type == 'inputNumber'" :label="v.label" :prop="v.modelValue">
                  <el-input-number v-model="$data.addForm[v.modelValue]" @change="handleChange"
                                   :min="1" :max="10" label="描述文字"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="submit" size="mini">确 定</el-button>
						<el-button @click="addMenuDialog = false" size="mini">取 消</el-button>
					</span>
        </el-dialog>
      </div>
      <!-- 修改Model -->
      <div class="editMenuDiglog">
        <el-dialog :title="editDialogTitle" :visible.sync="editMenuDialog" width="28%" :modal="false"
        				:before-close="handleClose" v-loading="loadingEdit">
          <el-form ref="form" :model="editForm" label-width="88px" size="mini">
            <el-row :gutter="20">
              <el-col :span="v.spanRows" type="flex" v-for="(v,i) in editFormType" :key="i">
                <!-- input -->
                <el-form-item v-if="v.type == 'input'" :label="v.label" :prop="v.modelValue">
                  <el-input :suffix-icon='v.prefix' v-model="$data.editForm[v.modelValue]"
                            :placeholder="v.placeholder" @focus='OpenIconsFocus(v,i)'></el-input>
                  <!-- icon自选区域 -->
                  <el-dialog title="选择一个菜单图标" :visible.sync="OpenIcons" width="48%" :modal="false"
                             :before-close="handleClose">
                    <div class="icon-list">
                      <div v-for="(v, index) in icons" :key="index" :value="v" class="icon-item"
                           @click="editSelectIcon(v)">
                        <i :class="v.icon"></i>
                        <span style="font-size: 12px;">{{v.title}}</span>
                      </div>
                    </div>
                  </el-dialog>
                </el-form-item>
                <!-- select -->
                <el-form-item v-if="v.type == 'MenuSelect'" :label="v.label" :prop="v.modelValue">
                  <el-select v-model="$data.editForm[v.modelValue]" filterable
                             :placeholder="v.placeholder" @focus="sname(v,i)" @change="scname">
                    <el-option v-for="item in $data[v.op]" :key="item.label" :label="item.label"
                               :value="item.id">
											<span
                          style="float: center;font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="v.type == 'firstSelect'" :label="v.label" :prop="v.modelValue">
                	<el-select v-model="$data.editForm[v.modelValue]" filterable
                				:placeholder="v.placeholder" @focus="sname(v,i)" @change="scname">
                		<!-- 关键修改：使用selectOptions作为数据源，value绑定id，label显示label -->
                		<el-option v-for="item in selectOptions" :key="item.id" :label="item.label"
                					:value="item.id">
                			<span style="float: center;font-size: 12px">{{ item.label }}</span>
                		</el-option>
                	</el-select>
                </el-form-item>
                <!-- 修改表单中的菜单名称 -->
                <el-form-item v-if="v.type == 'selectWithInput'" :label="v.label" :prop="v.modelValue">
                  <el-select v-model="$data.editForm[v.modelValue]" filterable allow-create
                             default-first-option :placeholder="v.placeholder" @focus="sname(v,i)"
                             @change="handleEditMenuNameChange" @blur="handleEditMenuNameBlur"
                             style="width: 100%">
                    <el-option v-for="(item,index) in combinedMenuOptions" :key="index"
                               :label="item.label" :value="item.label">
                      <span style="float: center;font-size: 12px">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="v.type == 'select'" :label="v.label" :prop="v.modelValue">
                  <el-select v-model="$data.editForm[v.modelValue]" filterable
                             :placeholder="v.placeholder" @focus="sname(v,i)" @change="scsname">
                    <el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label"
                               :value="item.id" :disabled="item.disabled">
											<span
                          style="float: center;font-size: 12px">{{ item.label }}</span></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="v.type == 'inputNumber'" :label="v.label" :prop="v.modelValue">
                  <el-input-number v-model="$data.editForm[v.modelValue]" @change="handleChange"
                                   :min="1" :max="10" label="描述文字"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="editSubmit" size="mini">确 定</el-button>
						<el-button @click="editMenuDialog = false" size="mini">取 消</el-button>
					</span>
        </el-dialog>
      </div>
	  <!-- 菜单设置Model -->
	  <div class="menuSettingsDialog">
	  	<el-dialog title="菜单设置" :visible.sync="settingsDialogVisible" width="360px" :modal="false"
	  				:before-close="handleSettingsClose">
	  		<el-form ref="settingsForm" :model="settings" label-width="" size="mini">
	  			<el-form-item label="允许空值查询" prop="allowEmptySearch">
	  				<el-checkbox v-model="settings.allowEmptySearch" 
	  								@change="handleEmptySearchChange">
	  					允许输入框为空时查询
	  				</el-checkbox>
	  			</el-form-item>
	  			
	  			<el-form-item label="默认展开所有菜单子项" prop="defaultExpandAll">
	  				<el-switch
	  					v-model="settings.defaultExpandAll"
	  					active-color="#13ce66"
	  					inactive-color="#ff4949"
	  					active-text="开"
	  					inactive-text="关"
	  					@change="handleExpandAllChange">
	  				</el-switch>
	  			</el-form-item>
	  			
	  			<!-- 设置说明 -->
	  			<el-alert
	  				title="设置说明"
	  				type="info"
	  				:closable="false"
	  				style="margin-top: 20px;"
	  				>
	  				<div style="font-size: 12px; line-height: 1.5;">
	  					<p>• 允许空值查询：勾选后可在搜索框为空时查询全部数据</p>
	  					<p>• 默认展开所有菜单子项：开启后菜单列表默认展开所有子项</p>
	  					<p>注：设置需点击"保存设置"按钮后生效</p>
	  				</div>
	  			</el-alert>
	  		</el-form>
	  		
	  		<span slot="footer" class="dialog-footer">
	  			<el-button @click="handleSettingsClose" size="mini">取 消</el-button>
	  			<el-button type="primary" @click="saveSettings" size="mini" :loading="savingSettings">
	  				保存设置
	  			</el-button>
	  		</span>
	  	</el-dialog>
	  </div>
    </div>
  </div>
</template>

<script>
// selfs / sons
import Pinyin from "@/external/pinyin.js";
import AccType from './AddType.js'
import editType from './editType.js'
import elMenus from '@/external/elMenus.js'
import icons from '@/external/icons.js'
// import * as echarts from "echarts";
// 接口
import { addMenu, AllMenu, removeMenu, editMenu, menuDetails } from "@/api/user.js";
export default {
  components: {

  },
  computed: {
    // 合并原有的菜单选项和用户自定义的选项
    combinedMenuOptions() {
      const originalOptions = this.elMenusOption.map(item => ({
        label: item.label,
        value: item.label,
        isCustom: false
      }));

      const customOptions = this.customMenuOptions.map(item => ({
        label: item,
        value: item,
        isCustom: true
      }));

      return [...originalOptions, ...customOptions];
    }
  },
  data() {
    return {
      idx: '',
      filterText: '',
      searchValue: '',
      selectValue: '',
      loading: false,
      loadingEdit: false, // 编辑加载状态
	  editDialogTitle: '修改菜单', // 编辑模态框标题
      disabled: true,
      Pidisabled: true, //父级菜单id禁用
      addMenuDialog: false,
      editMenuDialog: false,
      OpenIcons: false, //icons选择
      // 是否展开，默认全部展开
      isExpandAll: false,
      expandedRowKeys: [], // 用于存储默认展开的行的 id
      windowWidth: '',
      pageNum: 1, //当前页currentPage
      pageSize: 8,
      totalSize: 10, //总条数
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      options: [{
        value: '可用',
        label: '可用'
      }, {
        value: '禁用',
        label: '禁用'
      }],
		// 菜单设置相关
		savingSettings: false,  // 保存设置加载状态
		settingsDialogVisible: false,  // 设置模态框显示状态
		settings: {
			allowEmptySearch: true,     // 是否允许空值查询
			defaultExpandAll: false     // 默认展开所有菜单子项
		},
      menuTypeOptions: [{
        id: 1,
        label: '目录',
        value: 'M'
      }, {
        id: 2,
        label: '菜单',
        value: 'C'
      }, {
        id: 3,
        label: '按钮',
        value: 'F'
      }],
      // header查询重置按钮
      headerBtn: [],
      // 新增数据
      customMenuOptions: [], // 存储用户自定义的菜单选项
      menuInputValue: '', // 菜单名称输入值
      // 表单
      formType: [],
      editFormType: [],
      // icons
      icons: [],
      // 表格data
      tableData: [],
      elMenusOption: [], //菜单名称选择
      selectOptions: [],
      // 表格行
      tableRows: [{
        name: "权限标识",
        prop: "permission",
        type: ""
      }, {
        name: "路由地址",
        prop: "path",
        type: ""
      },
        {
          name: "组件名称",
          prop: "component",
          type: ""
        }, {
          name: "创建时间",
          prop: "createTime",
          type: ""
        }
      ],
      // 修改表单
      editForm: {
        menuId: '', //菜单id
        menuName: '', //菜单名称
        perms: '', // 标识符
        parentId: '', //菜单父id => 上级菜单
        type: '', //菜单类型（M目录 C菜单 F按钮）
        component: '', //组件名称
        icon: '', //菜单icon
        orderNum: '', //排序号
        path: '', //菜单路径
      },
      addForm: {
        menuName: '', //菜单名称
        perms: '', // 标识符
        parentId: '', //菜单父id => 上级菜单
        type: '', //菜单类型（M目录 C菜单 F按钮）
        component: '', //组件名称
        icon: '', //菜单icon
        orderNum: '', //排序号
        path: '', //菜单路径
      },
    }
  },
  mounted() {
  	// 左侧提交表单
  	this.formType = AccType.map(function(v) {
  		return v
  	})
  	// 左侧修改提交表单
  	this.editFormType = editType.map(function(v) {
  		return v
  	})
  	// 获取会话存储从钩子函数上获取到数据
  	this.loadData();
  	// 加载设置
  	this.loadSettingsFromStorage();
  	//获取动态盒子宽度，实时赋值给右侧 => this.$refs.mainRight.offsetWidth;
  	this.$nextTick(() => {
  		this.updateWindowWidth();
  		window.addEventListener('resize', this.updateWindowWidth);
  	})
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    async handleSearch() {
    	// 检查是否允许空值查询
    	if (!this.searchValue.trim()) {
    		// 从会话存储获取设置
    		const savedSettings = sessionStorage.getItem('menuManagementSettings');
    		let allowEmptySearch = true; // 默认允许
    		
    		if (savedSettings) {
    			try {
    				const parsedSettings = JSON.parse(savedSettings);
    				allowEmptySearch = parsedSettings.allowEmptySearch !== false;
    			} catch (error) {
    				console.error('解析设置失败:', error);
    			}
    		}
    		
    		if (!allowEmptySearch) {
    			this.$message.warning('此次登录已禁用空值查询！请保证输入的内容有效。');
    			return;
    		}
    	}
    	
    	this.loading = true;
    	try {
    		// 调用AllMenu接口进行搜索
    		let res = await AllMenu({
    			name: this.searchValue.trim()
    		});
    		
    		// 根据接口返回的数据结构进行处理
    		if (res) {
    			// 如果接口返回的是树形结构，需要提取所有匹配的节点
    			this.tableData = res.rows.children;
    			this.totalSize = res.total;
    			
    			// 检查是否需要展开所有行
    			const savedSettings = sessionStorage.getItem('menuManagementSettings');
    			if (savedSettings) {
    				try {
    					const parsedSettings = JSON.parse(savedSettings);
    					if (parsedSettings.defaultExpandAll) {
    						this.isExpandAll = true;
    						this.expandedRowKeys = this.getAllMenuIds(this.tableData);
    					} else {
    						this.isExpandAll = false;
    						this.expandedRowKeys = [];
    					}
    				} catch (error) {
    					console.error('解析展开设置失败:', error);
    				}
    			}
    			
    			// 如果需要分页，可以添加分页逻辑
    			if (this.totalSize > 0) {
    				this.$message.success(`查询到${this.totalSize}条记录`);
    			} else {
    				this.$message.warning('未找到匹配的菜单');
    			}
    		} else {
    			this.$message.error(res.message || '查询失败');
    			this.tableData = [];
    			this.totalSize = 0;
    		}
    	} catch (error) {
    		console.error('查询失败:', error);
    		this.$message.error('查询失败，请稍后重试');
    		this.tableData = [];
    		this.totalSize = 0;
    	} finally {
    		this.loading = false;
    	}
    },
    
    	// 新增：从树形数据中提取匹配搜索关键词的节点
    	extractMatchingNodes(menuTree, searchValue) {
    		const result = [];
    		
    		if (!menuTree || !searchValue) return result;
    		
    		const searchLower = searchValue.toLowerCase();
    		
    		// 递归遍历树形数据
    		const traverse = (nodes, parentPath = []) => {
    			for (const node of nodes) {
    				// 检查当前节点是否匹配搜索条件
    				const nodeName = node.label || node.name || '';
    				const nodePath = node.path || '';
    				const nodePerms = node.permission || '';
    				
    				if (nodeName.toLowerCase().includes(searchLower) || 
    					nodePath.toLowerCase().includes(searchLower) ||
    					nodePerms.toLowerCase().includes(searchLower)) {
    					
    					// 创建一个新对象，避免修改原始数据
    					const matchedNode = {
    						...node,
    						children: [] // 搜索模式下不显示子节点
    					};
    					
    					result.push(matchedNode);
    				}
    				
    				// 递归遍历子节点
    				if (node.children && node.children.length > 0) {
    					traverse(node.children, [...parentPath, node.label || node.name]);
    				}
    			}
    		};
    		
    		// 如果是数组，直接遍历
    		if (Array.isArray(menuTree)) {
    			traverse(menuTree);
    		} else if (menuTree.children && Array.isArray(menuTree.children)) {
    			// 如果是包含children的对象
    			traverse(menuTree.children);
    		}
    		
    		return result;
    	},

    // 刷新方法
    handleRefresh() {
    	this.loading = true;
    	this.searchValue = ''; // 清空搜索框
    	setTimeout(() => {
    		this.loadData();
    		this.$message({
    			type: 'success',
    			message: '已刷新'
    		});
    		this.loading = false;
    	}, 500);
    },

    // 设置方法
    handleSettings() {
    	// 打开菜单设置模态框
    	this.settingsDialogVisible = true;
    	
    	// 从会话存储加载设置
    	this.loadSettingsFromStorage();
    },

    // 全屏方法
    handleFullScreen() {
      this.$message.info('全屏功能开发中');
    },

    // 应用展开设置
    async loadData() {
    	try {
    		this.loading = true;
    		// 调用AllMenu接口获取所有菜单
    		let res = await AllMenu();
    		
    		if (res) {
    			// 根据接口返回的数据结构处理
    			this.tableData = res.rows.children || res.rows || [];
    			this.totalSize = res.total || 0;
    			
    			console.log('所有菜单加载完成:', {
    				数据条数: this.tableData.length,
    				总数: this.totalSize
    			});
    			
    			// 从会话存储加载设置
    			const savedSettings = sessionStorage.getItem('menuManagementSettings');
    			if (savedSettings) {
    				try {
    					const parsedSettings = JSON.parse(savedSettings);
    					if (parsedSettings.defaultExpandAll) {
    						this.isExpandAll = true;
    						this.expandedRowKeys = this.getAllMenuIds(this.tableData);
    					} else {
    						this.isExpandAll = false;
    						this.expandedRowKeys = [];
    					}
    				} catch (error) {
    					console.error('解析展开设置失败:', error);
    				}
    			}
    			
    			// 将菜单里还未新增之前的数据源存放于会话，以便角色默认使用。
    			sessionStorage.setItem('MenuForRoleItems', JSON.stringify(this.tableData));
    		} else {
    			this.$message.error(res.message || '获取菜单列表失败');
    			this.tableData = [];
    			this.totalSize = 0;
    		}
    	} catch (error) {
    		console.error('加载数据失败:', error);
    		this.$message.error('加载数据失败');
    		this.tableData = [];
    		this.totalSize = 0;
    	} finally {
    		this.loading = false;
    	}
    },
	
    // 处理菜单名称变化（新增表单）
    handleMenuNameChange(value) {
      if (value && !this.combinedMenuOptions.some(item => item.label === value)) {
        this.addCustomMenuOption(value);
      }

      const selectedMenu = this.combinedMenuOptions.find(item => item.label === value);
      if (selectedMenu && !selectedMenu.isCustom) {
        const originalMenu = this.elMenusOption.find(item => item.label === value);
        if (originalMenu) {
          this.addForm.path = originalMenu.path || '';
          this.addForm.icon = originalMenu.icon || '';
          this.addForm.component = originalMenu.component || 'Layout';
        }
      }
    },
	// 加载设置
	loadSettingsFromStorage() {
		try {
			const savedSettings = sessionStorage.getItem('menuManagementSettings');
			if (savedSettings) {
				const parsedSettings = JSON.parse(savedSettings);
				this.settings.allowEmptySearch = parsedSettings.allowEmptySearch !== false; // 默认true
				this.settings.defaultExpandAll = parsedSettings.defaultExpandAll || false;
				
				// 根据设置更新表格展开状态
				if (this.settings.defaultExpandAll) {
					this.isExpandAll = true;
					this.expandedRowKeys = this.getAllMenuIds(this.tableData);
				} else {
					this.isExpandAll = false;
					this.expandedRowKeys = [];
				}
			}
		} catch (error) {
			console.error('加载设置失败:', error);
			// 使用默认设置
			this.settings.allowEmptySearch = true;
			this.settings.defaultExpandAll = false;
		}
	},
	
	// 保存设置
	saveSettings() {
		this.savingSettings = true;
		
		try {
			// 保存到会话存储
			sessionStorage.setItem('menuManagementSettings', JSON.stringify(this.settings));
			
			// 根据设置更新表格状态
			if (this.settings.defaultExpandAll) {
				this.isExpandAll = true;
				this.expandedRowKeys = this.getAllMenuIds(this.tableData);
			} else {
				this.isExpandAll = false;
				this.expandedRowKeys = [];
			}
			
			this.$message.success('设置保存成功');
			
			// 延迟关闭模态框
			setTimeout(() => {
				this.settingsDialogVisible = false;
				this.savingSettings = false;
			}, 800);
			
		} catch (error) {
			console.error('保存设置失败:', error);
			this.$message.error('保存设置失败');
			this.savingSettings = false;
		}
	},
	// 获取所有菜单ID（用于展开所有行）
	getAllMenuIds(menuTree) {
		const ids = [];
		
		if (!menuTree || !Array.isArray(menuTree)) {
			return ids;
		}
		
		const collectIds = (nodes) => {
			nodes.forEach(node => {
				if (node.id) {
					ids.push(node.id);
				}
				if (node.children && node.children.length > 0) {
					collectIds(node.children);
				}
			});
		};
		
		collectIds(menuTree);
		return ids;
	},
	
	// 关闭设置模态框
	handleSettingsClose(done) {
		this.$confirm('确认关闭？未保存的设置将丢失', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			// 重新加载保存的设置
			this.loadSettingsFromStorage();
			this.settingsDialogVisible = false;
			if (done) done();
		}).catch(() => {
			// 用户取消关闭
		});
	},
	// 处理允许空值查询变化
	handleEmptySearchChange(val) {
		console.log('允许空值查询设置:', val ? '已允许' : '已禁用');
	},
	
	// 处理展开所有子项变化
	handleExpandAllChange(val) {
		console.log('默认展开所有子项设置:', val ? '已开启' : '已关闭');
	},
    // 处理菜单名称失去焦点（新增表单）
    handleMenuNameBlur(event) {
      const value = event.target.value;
      if (value && !this.combinedMenuOptions.some(item => item.label === value)) {
        this.addCustomMenuOption(value);
        this.addForm.menuName = value;
      }
    },

    // 处理菜单名称变化（修改表单）
    handleEditMenuNameChange(value) {
      if (value && !this.combinedMenuOptions.some(item => item.label === value)) {
        this.addCustomMenuOption(value);
      }

      const selectedMenu = this.combinedMenuOptions.find(item => item.label === value);
      if (selectedMenu && !selectedMenu.isCustom) {
        const originalMenu = this.elMenusOption.find(item => item.label === value);
        if (originalMenu) {
          this.editForm.path = originalMenu.path || '';
          this.editForm.icon = originalMenu.icon || '';
          this.editForm.component = originalMenu.component || 'Layout';
        }
      }
    },

    // 处理菜单名称失去焦点（修改表单）
    handleEditMenuNameBlur(event) {
      const value = event.target.value;
      if (value && !this.combinedMenuOptions.some(item => item.label === value)) {
        this.addCustomMenuOption(value);
        this.editForm.menuName = value;
      }
    },

    // 添加自定义菜单选项
    addCustomMenuOption(menuName) {
      if (!this.customMenuOptions.includes(menuName)) {
        this.customMenuOptions.push(menuName);
        this.$message({
          type: 'success',
          message: `已添加新菜单选项: ${menuName}`
        });
      }
    },

    // select聚焦
    async sname(v, i) {
    	this.idx = i;
    	switch (i) {
    		case 0: // 菜单类型
    			this.menuTypeOptions = [{
    				id: 1,
    				label: '目录',
    				value: 'M'
    			}, {
    				id: 2,
    				label: '菜单',
    				value: 'C'
    			}, {
    				id: 3,
    				label: '按钮',
    				value: 'F'
    			}];
    			break;
    			
    		case 1: // 上级菜单
    			// 关键修改：如果已经处理过selectOptions，直接使用
    			if (this.selectOptions && this.selectOptions.length > 0) {
    				console.log('使用已生成的上级菜单选项:', this.selectOptions.length);
    			} else {
    				// 如果selectOptions为空，重新加载
    				console.log('selectOptions为空，重新获取菜单数据');
    				try {
    					const res = await AllMenu();
    					if (res) { // 修改：不需要检查code
    						const allMenuChildren = res.rows.children || res.rows || [];
    						this.processParentMenuOptions(allMenuChildren);
    					}
    				} catch (error) {
    					console.error('加载上级菜单选项失败:', error);
    				}
    			}
    			break;
    			
    		case 2: // 菜单名称
    			this.elMenusOption = this.flattenChildren(elMenus);
    			
    			// 获取所有菜单用于过滤
    			let allMenus = [];
    			try {
    				const res = await AllMenu();
    				if (res) { // 修改：不需要检查code
    					const allMenuChildren = res.rows.children || res.rows || [];
    					allMenus = this.flattenChildren(allMenuChildren);
    				}
    			} catch (error) {
    				console.error('加载菜单用于过滤失败:', error);
    			}
    			
    			let namesInB = new Set(allMenus.map(item => item.label));
    			this.elMenusOption = this.elMenusOption.map(item => {
    				if (namesInB.has(item.label)) {
    					return {
    						...item,
    						disabled: true
    					};
    				}
    				return item;
    			});
    			break;
    	}
    },

    // 修改：新增按钮点击
    addMenuhandClick(i) {
    	switch (i) {
    		case 0:
    			// 在打开新增模态框时也加载上级菜单选项
    			this.loadParentOptionsForAdd();
    			this.addMenuDialog = true;
    			break;
    	}
    },
    
    // 新增：为新增功能加载上级菜单选项
    async loadParentOptionsForAdd() {
    	try {
    		console.log('为新增功能加载上级菜单选项...');
    		const res = await AllMenu();
    		if (res) { // 修改：不需要检查code
    			const allMenuChildren = res.rows.children || res.rows || [];
    			this.processParentMenuOptions(allMenuChildren);
    		}
    	} catch (error) {
    		console.error('加载新增上级菜单选项失败:', error);
    	}
    },

    // SelectVal to editForm
    scname(val) {
      console.log(val, this.idx);
      switch (this.idx) {
        case 0:
          if (val == 1) {
            this.editForm.type = 'M'
          } else if (val == 2) {
            this.editForm.type = 'C'
          } else {
            this.editForm.type = 'F'
          }
          break;
        case 1:
          let qwer = this.findObjectByCode(this.selectOptions, val);
          console.log(qwer)
          break;
      }
    },

    // SelectVal to editForm
    scsname(val) {
      switch (this.idx) {
        case 0:
          if (val == 'M') {
            this.Pidisabled = true;
            this.addForm.parentId = 0
            this.formType[2].type = 'selectWithInput'
            this.formType[2].label = '目录名称'
            this.formType[3].label = '目录图标'
            this.formType[4].label = '目录路径'
          } else if (val == 'C') {
            this.Pidisabled = false;
            this.formType[2].type = 'selectWithInput'
            this.formType[2].label = '菜单名称'
            this.formType[3].label = '菜单图标'
            this.formType[4].label = '菜单路径'
          } else {
            this.Pidisabled = false;
            this.formType[2].type = 'selectWithInput'
            this.formType[2].label = '按钮名称'
            this.formType[3].label = '按钮图标'
            this.formType[4].label = '按钮路径'
          }
          break;
      }

      let a = this.elMenusOption.map(item => {
        if (item.id == val) {
          this.addForm.path = item.path
          this.addForm.icon = item.icon
          this.addForm.menuName = item.label
          item.component == undefined || item.component == '' ? this.addForm.component = 'Layout' :
              this.addForm.component = item.component
        }
      })
    },

    // 提交
    async submit() {
      console.log(this.addForm);
      let rs = await addMenu(this.addForm);
      if (rs.code === 200) {
        this.$message({
          type: 'success',
          message: '菜单新增成功！'
        });
        this.loadData();
        this.addMenuDialog = false
        this.expandedRowKeys.push(this.editForm.menuId);
        this.editMenuDialog = false;
      } else {
        this.$message.error(rs.message)
      }
    },
    /*
      about tree
    */
    handleNodeClick(data, e) {
      this.CatalogueName = data.title
      this.iconComes = 'el-icon-' + this.makePy(data.label)
      // this.loadData();
    },
    // 过滤器
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleIconClose(done) {
      done();
    },
    handleClose(done) {
      this.$confirm('关闭会清空已选择的数据，确认关闭？')
          .then(_ => {
            // 先重置表单
            this.$nextTick(() => {
              this.$refs['addForm'].resetFields(); // 等待 DOM 更新后重置
            });
            // 再执行关闭
            setTimeout(() => done(), 0); // 确保重置完成后再关闭
          })
          .catch(_ => {});
    },
    // 递归二级children
    extractSecondLevelChildren(data) {
      const result = [];
      data.forEach(item => {
        if (item.children && item.children.length > 0) {
          result.push(...item.children);
        }
      });
      return result;
    },
    // 递归三级children
    extractLeafChildren(data) {
      const result = [];
      data.forEach((item) => {
        if (item.children && item.children.length > 0) {
          // 递归提取子级
          result.push(...this.extractLeafChildren(item.children));
        } else {
          // 当前节点没有 children 或 children 为空，视为叶节点
          result.push(item);
        }
      });
      return result;
    },
    // 递归三级children => 不包含type=f 按钮的
    processMenuData(data) {
      const result = [];

      function traverse(item) {
        // 创建一个新的对象，避免修改原始数据
        const newItem = {
          ...item
        };
        delete newItem.children; // 删除 children 字段
        // 如果当前项的 type 不是 'F'，则添加到结果数组中
        if (item.type !== 'F') {
          result.push(newItem);
          // 如果有 children 且 type 不是 'F'，则递归处理子项
          if (item.children && item.children.length > 0) {
            item.children.forEach(child => {
              traverse(child);
            });
          }
        }
      }

      // 遍历根节点
      data.forEach(node => {
        traverse(node);
      });

      return result;
    },
    // 递归查找函数 2
    findObjectByCode(arr, targetCode) {
      for (const obj of arr) {
        // 检查当前对象的 areaCode 是否匹配
        if (obj.id === targetCode) {
          return obj; // 找到目标，直接返回
        }
        // 如果存在子节点（假设子节点存储在 children 属性中），递归查找
        if (obj.children && obj.children.length > 0) {
          const found = this.findObjectByCode(obj.children, targetCode);
          if (found) {
            return found; // 子节点中找到目标，逐层返回
          }
        }
      }
      return null; // 遍历完未找到
    },
    // 计数器
    handleChange(value) {

    },
    //  icons聚焦
    OpenIconsFocus(v, i) {
      // v.id = i;
      // this.idx = i;
      // i event
      switch (i) {
        case 3:
          // 打开菜单icon选择model
          this.OpenIcons = true;
          this.icons = icons.map(function(v) {
            return v
          })
          break;
      }
    },
    // icon选择 => 新增
    selectIcon(v) {
      this.addForm.icon = v.icon
      this.OpenIcons = false
    },
    // icon选择 => 修改
    editSelectIcon(v) {
      this.editForm.icon = v.icon
      this.OpenIcons = false
    },
    // 步骤
    handClick(i) {
      // i event
      switch (i) {
        case 0:
          // 处理索引0的逻辑 页面刷新
          this.loading = true;
          setTimeout(() => {
            this.loadData();
            this.$message({
              type: 'success',
              message: '已刷新'
            })
            this.loading = false;
          }, 1500)
          break;
        case 1:
          // 处理索引1的逻辑
          this.$confirm('敬请期待')
              .then(_ => {})
              .catch(_ => {});
          break;
      }
    },

    // col 里面包含了表头字段和名称，list 是表格数据
    columnWidth(col, list) {
      let prop = col.prop,
          lab = col.lab;
      let width = 20; // 设定一个最小值
      let maxlenStr = ""; // 最长字符串
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      // 表格自带的内边距(20px) 自调

      return width + 8; // 这里加了 12px
      function len(str) {
        // 实际分配长度可根据需要自行调整
        let length = 0;
        for (const char of str + "") {
          // 英文小写字符 8px
          if ("a" <= char && char <= "z") length += 8;
          // 英文小写字符 8px
          if ("a" <= char && char <= "z") length += 8;
          // 英文大写字符 12px
          else if ("A" <= char && char <= "Z") length += 8;
          // 中文字符 16px
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 24;
          // 其他 8px
          else length += 8;
        }
        return length;
      }
    },
    // db events
    handledbRow(row, column, event) {

    },
    //分页
    //每页条数改变触发
    handleSizeChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    //当前条数改变触发
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    // 实时宽度
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 228;
    },
    toggleExpand(row) {
      this.$refs.table.toggleRowExpansion(row);
      row.expanded = !row.expanded
    },
    
	// 优化后的表格编辑栏方法
	async handleEdit(row) {
		try {
			// 设置编辑加载状态
			this.loadingEdit = true;
			
			console.log('编辑行数据:', row);
			
			// 先填充基础数据，确保模态框快速显示
			this.editForm = {
				menuId: row.id || '',
				menuName: row.label || row.name || '',
				perms: row.permission || '',
				parentId: row.parentId || '',
				type: row.type || '',
				component: row.component || 'Layout',
				icon: row.icon || '',
				orderNum: row.order || row.orderNum || '',
				path: row.path || ''
			};
			
			// 打开编辑模态框
			this.editMenuDialog = true;
			
			// 修改模态框标题
			this.editDialogTitle = `修改菜单 - ID:${row.id} - ${row.label || row.name || ''}`;
			
			// 如果没有菜单ID，使用当前行数据
			if (!row.id) {
				this.$message.warning('菜单ID为空，使用当前行数据');
				return;
			}
			
			// 关键修改1：在编辑时重新调用AllMenu接口获取完整的菜单数据
			console.log('正在获取完整的菜单数据用于上级菜单选择...');
			let allMenuRes = await AllMenu();
			
			// 关键修改2：修正条件判断，不需要检查code
			if (!allMenuRes) {
				this.$message.error('获取完整菜单数据失败');
				return;
			}
			
			// 关键修改3：从AllMenu接口返回的数据中提取所有菜单
			const allMenuChildren = allMenuRes.rows.children || allMenuRes.rows || [];
			console.log('从AllMenu接口获取的完整菜单数据:', allMenuChildren);
			
			// 关键修改4：处理菜单数据，生成上级菜单选项
			this.processParentMenuOptions(allMenuChildren);
			
			// 关键修改5：调用menuDetails接口获取当前菜单详情
			const response = await menuDetails({
				id: row.id
			});
			
			console.log('menuDetails接口返回数据:', response);
			
			if (response.code === 200 && response.data) {
				const menuDetail = response.data;
				
				// 处理菜单类型：将 "C" 转换为对应的中文标签
				let typeLabel = '';
				switch(menuDetail.type) {
					case 'M':
						typeLabel = '目录';
						break;
					case 'C':
						typeLabel = '菜单';
						break;
					case 'F':
						typeLabel = '按钮';
						break;
					default:
						typeLabel = menuDetail.type || '';
				}
				
				// 关键修改6：确保parentId转换为数字类型
				let parentId = menuDetail.parentId;
				
				// 转换parentId为数字类型
				if (parentId) {
					// 如果是字符串，转换为数字
					if (typeof parentId === 'string') {
						parentId = Number(parentId);
						console.log(`将字符串parentId转换为数字: ${menuDetail.parentId} -> ${parentId}`);
					}
				}
				
				// 设置编辑表单的parentId为数字ID，让Element UI自动匹配label
				if (parentId && parentId !== 0) {
					// 确保是数字类型
					this.editForm.parentId = Number(parentId);
				} else {
					this.editForm.parentId = 0; // 设置为0，对应"无 (顶级菜单)"
				}
				
				// 用接口返回的最新数据更新表单
				this.editForm = {
					...this.editForm,
					menuId: menuDetail.id || row.id,
					menuName: menuDetail.label || menuDetail.name || this.editForm.menuName,
					perms: menuDetail.permission || menuDetail.perms || this.editForm.perms,
					type: typeLabel, // 显示中文标签而不是字母代码
					component: menuDetail.component || this.editForm.component || 'Layout',
					icon: menuDetail.icon || this.editForm.icon,
					orderNum: menuDetail.order || menuDetail.orderNum || this.editForm.orderNum,
					path: menuDetail.path || this.editForm.path
				};
				
				// 存储原始值，用于表单提交
				this.editForm._originalParentId = parentId; // 存储parentId
				this.editForm._originalType = menuDetail.type;
				
				console.log('处理后的编辑表单数据:', {
					...this.editForm,
					parentId: this.editForm.parentId,
					parentId类型: typeof this.editForm.parentId,
					originalParentId: this.editForm._originalParentId
				});
				
				// 关键修改7：检查当前parentId是否在selectOptions中
				// 使用宽松比较，确保数字和字符串都能匹配
				const parentOption = this.selectOptions.find(item => item.id == parentId);
				console.log('查找上级菜单选项:', {
					查找的parentId: parentId,
					parentId类型: typeof parentId,
					selectOptions长度: this.selectOptions.length,
					找到的选项: parentOption
				});
				
				if (parentOption) {
					console.log(`上级菜单已自动匹配: ID=${parentId}, Label=${parentOption.label}`);
				} else {
					console.warn(`上级菜单ID=${parentId}在selectOptions中未找到匹配项`);
					// 调试：查看selectOptions中的所有选项
					console.log('selectOptions选项列表:', this.selectOptions.map(item => ({
						id: item.id,
						id类型: typeof item.id,
						label: item.label
					})));
				}
				
				this.$message.success('已加载最新菜单详情数据');
			} else {
				// 使用当前行数据，并进行转换
				const typeLabel = this.convertTypeToLabel(row.type);
				let parentId = row.parentId;
				
				// 转换parentId为数字类型
				if (parentId) {
					if (typeof parentId === 'string') {
						parentId = Number(parentId);
					}
				}
				
				// 设置编辑表单的parentId
				if (parentId && parentId !== 0) {
					this.editForm.parentId = Number(parentId); // 确保是数字类型
				} else {
					this.editForm.parentId = 0; // 设置为0
				}
				
				this.editForm.type = typeLabel;
				this.editForm._originalParentId = parentId;
				this.editForm._originalType = row.type;
				
				console.log('使用当前行数据:', {
					menuId: row.id,
					parentId: parentId,
					parentId类型: typeof parentId,
					editFormParentId: this.editForm.parentId,
					editFormParentId类型: typeof this.editForm.parentId,
					typeLabel: typeLabel
				});
				
				this.$message.info('使用当前行数据（未获取到最新数据）');
			}
		} catch (error) {
			console.error('获取菜单详情失败:', error);
			this.$message.error('获取菜单详情失败，使用当前行数据');
		} finally {
			this.loadingEdit = false;
		}
	},
	
	// 新增：处理上级菜单选项
	processParentMenuOptions(allMenuChildren) {
		// 创建选项数组
		const options = [{
			id: 0,
			label: '无 (顶级菜单)',
			value: 0
		}];
		
		// 递归处理所有菜单
		const processMenuRecursive = (menuList, level = 0) => {
			menuList.forEach(menu => {
				// 只添加类型不为'F'的菜单作为上级菜单选项
				if (menu.type !== 'F') {
					const prefix = '　'.repeat(level) + (level > 0 ? '├─ ' : '');
					const menuLabel = menu.label || menu.name || `菜单 ${menu.id}`;
					
					// 关键修改：确保id是数字类型
					const menuId = Number(menu.id);
					
					options.push({
						id: menuId, // 确保是数字类型
						label: prefix + menuLabel,
						value: menuId
					});
					
					// 递归处理子菜单
					if (menu.children && menu.children.length > 0) {
						processMenuRecursive(menu.children, level + 1);
					}
				}
			});
		};
		
		// 处理所有菜单
		if (allMenuChildren && allMenuChildren.length > 0) {
			processMenuRecursive(allMenuChildren);
			console.log(`生成上级菜单选项完成，共${options.length}个选项`);
			
			// 调试：检查选项的id类型
			const idTypes = options.map(item => ({
				id: item.id,
				id类型: typeof item.id,
				label: item.label
			}));
			console.log('生成的选项ID类型检查:', idTypes.slice(0, 5)); // 只显示前5个
		}
		
		// 保存到selectOptions
		this.selectOptions = options;
		
		return options;
	},
	// 新增：将菜单类型代码转换为中文标签
	convertTypeToLabel(typeCode) {
		switch(typeCode) {
			case 'M':
				return '目录';
			case 'C':
				return '菜单';
			case 'F':
				return '按钮';
			default:
				return typeCode || '';
		}
	},
	
	// 新增：将中文标签转换为菜单类型代码
	convertLabelToType(typeLabel) {
		switch(typeLabel) {
			case '目录':
				return 'M';
			case '菜单':
				return 'C';
			case '按钮':
				return 'F';
			default:
				return typeLabel || 'C';
		}
	},
	
	// 新增：在树形数据中根据ID查找菜单
	findMenuById(menuTree, menuId) {
		if (!menuTree || !menuId) return null;
		
		const findRecursive = (nodes) => {
			for (const node of nodes) {
				if (node.id === menuId) {
					return node;
				}
				if (node.children && node.children.length > 0) {
					const found = findRecursive(node.children);
					if (found) return found;
				}
			}
			return null;
		};
		
		return findRecursive(menuTree);
	},
	
	// 新增：在树形数据中根据标签查找菜单
	findMenuByLabel(menuTree, menuLabel) {
		if (!menuTree || !menuLabel) return null;
		
		const findRecursive = (nodes) => {
			for (const node of nodes) {
				if (node.label === menuLabel || node.name === menuLabel) {
					return node;
				}
				if (node.children && node.children.length > 0) {
					const found = findRecursive(node.children);
					if (found) return found;
				}
			}
			return null;
		};
		
		return findRecursive(menuTree);
	},
	// 新增：根据ID查找表格行索引
	findRowIndexById(id) {
		return this.tableData.findIndex(item => item.id === id);
	},

    // 新增：在树形数据中查找菜单项（支持按ID和名称双重匹配）
    findMenuInTree(menuTree, menuId, menuName) {
      if (!menuTree) return null;

      const findRecursive = (nodes) => {
        for (const node of nodes) {
          // 优先按ID匹配，其次按名称匹配
          if (node.id === menuId || node.label === menuName || node.name === menuName) {
            return node;
          }

          // 递归查找子节点
          if (node.children && node.children.length > 0) {
            const found = findRecursive(node.children);
            if (found) return found;
          }
        }
        return null;
      };

      return findRecursive(menuTree);
    },
    // 修改提交
    async editSubmit() {
      console.log(this.editForm);
      let rs = await editMenu(this.editForm);
      if (rs.code === 200) {
        this.$message({
          type: 'success',
          message: '菜单修改成功！',
        });
        //更新数据源
        this.loadData();
        // 动态设置默认展开的行
        this.expandedRowKeys.push(this.editForm.menuId); // 设置默认展开的行的 id
        this.editMenuDialog = false;
      } else {
        this.$message.error(rs.message)
      }
    },
    //删除菜单
    handleDelete(id) {
      this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await removeMenu({
          menuIds: id
        })
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: res.message
          });
          this.loadData(); //重新加载数据页面
        } else {
          this.$message({
            type: "error",
            message: res.message
          });
        }
      }).catch(() => {
        this.$message({
          type: "error",
          message: '取消'
        });
      });
    },
    // 数组扁平化
    flattenChildren(data) {
      const result = []; // 用于存储提取的数据

      // 递归函数
      function traverse(node) {
        // 如果当前节点的 type 不是 'F'，则处理该节点
        if (node.type !== 'F') {
          // 将当前节点添加到结果数组中
          const newNode = {
            ...node
          };
          delete newNode.children; // 删除 children 字段
          result.push(newNode);

          // 如果当前节点有 children，递归处理子节点
          if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
              traverse(child);
            });
          }
        }
      }

      // 遍历根节点
      data.forEach(node => {
        traverse(node);
      });

      return result;
    },
  },
  watch: {
    windowWidth(newVal) {
      // 在这里执行逻辑，例如重新布局等。
    }
  }
}
</script>

<style lang="less" scoped>
// 穿透
/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.user {
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;

  .contentMain {
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 16px;

    .title {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e8e8e8;
      margin-bottom: 16px;

      span {
        font-weight: 600;
        font-size: 16px;
        color: #303133;
        margin-left: 0;
      }
    }

    .main {
      width: 100%;
      display: flex;

      .main-right {
        width: 100%;

        .searchValue {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          padding: 16px;
          background: #f8f9fa;
          border-radius: 6px;

          .leftBtn {
            display: flex;
            align-items: center;
            gap: 8px;

            /deep/ .el-input {
              width: 200px;

              .el-input__inner {
                border-radius: 4px;
              }
            }

            /deep/ .el-button {
              border-radius: 4px;
              font-weight: 500;
            }
          }

          .rightBtn {
            display: flex;
            align-items: center;
            gap: 8px;

            /deep/ .el-button {
              border-radius: 4px;
              font-weight: 500;

              &:first-child {
                background: #007bb0;
                border-color: #007bb0;
              }

              &:not(:first-child) {
                color: #007bb0;
                border-color: #007bb0;

                &:hover {
                  background: #007bb0;
                  color: #fff;
                }
              }
            }
          }
        }

        .content {
          width: 100%;
          margin-top: 0;
          border: 1px solid #e8e8e8;
          border-radius: 6px;
          overflow: hidden;

          /deep/ .el-table {
            background-color: #fff;

            .el-table__header-wrapper {
              background: #f5f7fa;

              th {
                background: #f5f7fa;
                color: #606266;
                font-weight: 600;
              }
            }

            .el-table__body-wrapper {
              .el-table__row {
                &:hover {
                  background: #f5f7fa;
                }
              }
            }

            .cell {
              font-size: 12px;
              height: 40px;
              line-height: 40px;
              color: #606266;
            }

            .el-table--border .el-table__cell,
            .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
              border-right: 1px solid #e8e8e8;
            }

            td {
              padding: 0 !important;
              height: 40px;
              border-bottom: 1px solid #e8e8e8;
            }

            .el-table td.el-table__cell div :first-child {
              text-align: center;
            }

            .el-tag {
              border-radius: 12px;
              font-size: 10px;
              padding: 0 6px;
              height: 20px;
              line-height: 20px;
            }
          }
        }

        .foot {
          display: flex;
          justify-content: flex-end;
          margin-top: 16px;

          /deep/ .el-pagination {
            .el-pager li {
              border-radius: 4px;
              background: #f5f7fa;

              &.active {
                background: #007bb0;
                color: #fff;
              }
            }
          }
        }
      }
    }
	/* 菜单设置模态框样式 */
	.menuSettingsDialog {
		/deep/ .el-dialog__header {
			padding: 12px;
			background-color: #007bb0;
		}
		
		/deep/ .el-dialog__title {
			font-size: 12px;
			color: #fff;
		}
		
		/deep/ .el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}
		
		/deep/ .el-dialog__body {
			padding: 20px;
			
			.el-form-item {
				margin-bottom: 20px;
				
				.el-form-item__label {
					font-weight: 500;
					color: #606266;
					font-size: 12px;
				}
				
				.el-checkbox {
					.el-checkbox__label {
						font-size: 12px;
						color: #606266;
					}
					
					.el-checkbox__inner {
						width: 16px;
						height: 16px;
						
						&::after {
							left: 5px;
							top: 1px;
							width: 4px;
							height: 8px;
						}
					}
				}
				
				.el-switch {
					.el-switch__core {
						width: 40px;
						height: 20px;
						
						&:after {
							width: 16px;
							height: 16px;
						}
					}
					
					&.is-checked .el-switch__core::after {
						margin-left: -16px;
					}
					
					.el-switch__label {
						font-size: 12px;
						
						&.is-active {
							color: #13ce66;
						}
					}
				}
			}
			
			.el-alert {
				padding: 12px 16px;
				
				.el-alert__title {
					font-size: 12px;
					font-weight: 500;
				}
				
				.el-alert__description {
					p {
						margin: 4px 0;
						
						&:last-child {
							margin-top: 8px;
							color: #909399;
							font-style: italic;
						}
					}
				}
			}
		}
		
		/deep/ .dialog-footer {
			.el-button {
				border-radius: 4px;
				font-weight: 500;
				
				&:last-child {
					background: #007bb0;
					border-color: #007bb0;
				}
			}
		}
	}
    .addMenuDiglog,
    .editMenuDiglog {
      .icon-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 12px;
        max-height: 400px;
        overflow-y: auto;

        .icon-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 80px;
          height: 80px;
          border: 1px solid #e8e8e8;
          color: #606266;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease;
          padding: 8px;

          i {
            font-size: 24px;
            margin-bottom: 8px;
          }

          span {
            font-size: 10px;
            text-align: center;
            line-height: 1.2;
          }

          &:hover {
            background-color: #007bb0;
            color: #fff;
            border-color: #007bb0;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 123, 176, 0.3);
          }
        }
      }

      /deep/ .el-dialog {
        border-radius: 8px;

        .el-dialog__body {
          padding: 20px;

          .el-form-item {
            margin-bottom: 16px;

            .el-form-item__label {
              color: #606266;
              font-weight: 500;
            }

            .el-input__inner,
            .el-select {
              border-radius: 4px;
            }
          }
        }

        .dialog-footer {
          .el-button {
            border-radius: 4px;
            font-weight: 500;

            &:first-child {
              background: #007bb0;
              border-color: #007bb0;
            }
          }
        }
      }
    }
  }
}
</style>